"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Header = exports.Header = _styledComponents["default"].header.withConfig({
  displayName: "Header",
  componentId: "sc-5nwm8m-0"
})(["border-block-end:1px solid ", ";position:relative;@media (max-width:", "){padding-block:14px;padding-inline:", " calc(", " + (", " * 2));}@media (min-width:", "){padding-block:", ";padding-inline:calc(", " * 3);text-align:center;}"], function (props) {
  return "var(--decorative-subdued, ".concat(_index.defaultTheme[props.$colorSet].decorative.subdued, ")");
}, _encoreFoundation.screenXsMax, (0, _index.cssLayoutMargin)('base', '24px'), (0, _index.cssLayoutMargin)('base', '24px'), (0, _index.cssLayoutMargin)('tighter', '16px'), _encoreFoundation.screenSmMin, (0, _index.cssSpacing)('looser', '20px'), (0, _index.cssLayoutMargin)('base', '24px'));